/**
 * Created by cuppi on 2016/11/22.
 */
import ReleaseConfig from 'release-config'
class GlobalConstant {
  // 网络请求超时时间
  static baseUrl = ReleaseConfig.baseUrl;
  static isSimulateLogin = ReleaseConfig.isSimulateLogin;
  static timeout = 8888;
  /**
   * 在StoreConfig初始化了
   * @type {{}}
   */
  static store = null;
  static router = null;
}

export default GlobalConstant;
